import axios from 'axios'
import { basePriceUrl } from 'services/api/config'
const url = `${basePriceUrl}/system_quotations`

function createWaypoint (params) {
  const { lat, lng, address, country } = params
  return ({
    location: {
      lat,
      lng,
    },
    addresses: {
      zh_HK: { // locale?
        displayString: address,
        country,
      },
    },
  })
}

// serviceType (HK)
// MOTORCYCLE, 40 × 40 × 40 cm, 10kg
// VAN, 182 × 121 × 121 cm, 700 - 800 kg
// TRUCK550, 450 × 195 × 195 cm, 800 - 1,200 kg
export async function getLalamoveQuotation (params, retrys = 3) {
  const {
    serviceType = 'MOTORCYCLE',
    specialRequests = [], // optional
    locale,
    pickupAt,
    scheduleAt,
    waypoints,
    remarks = '', // Additional info about the delivery. eg. building, floor and flat. Use newline \r\n for better readability
    orderAmount = 0,
    merchantId = '',
  } = params

  const stops = waypoints.map(point => {
    const params = { ...point, locale }
    return createWaypoint(params)
  })

  // Array of DeliveryInfos, stops[1] (customer contact)
  const deliveries = [{
    toStop: 1,
    toContact: {
      name: 'Chris Wong',
      phone: '37013701',
    },
    remarks: remarks, // optional
  }]

  // Contact person at pick up point aka stops[0] (merchant contact)
  const requesterContact = {
    name: 'Chris Wong',
    phone: '37013701',
  }

  const request = {
    scheduleAt, // optional Pick up time in UTC timezone and ISO 8601 format; omit this if you are placing an immediate order
    serviceType,
    stops, // <Waypoint>[]
    deliveries, // <DeliveryInfo>[]
    requesterContact, // <Contact> e.g. { name: 'Chris Wong', phone: '37013701' }, phone must pass phone validation. (by country/region)
    specialRequests, // optional e.g. ['COD', 'HELP_BUY', 'LALABAG'], HK has no available specialRequest.
    orderAmount,
    merchantId,
  }

  console.log('request', { request })

  try {
    const res = await axios.post(url, request, {
      headers: {
        'X-LLM-Country': 'HK',
      },
    })

    return { ...res.data, scheduleAt, pickupAt }
  } catch (error) {
    console.log('lalamove priceing error', error)
    const isTimoutError = true // TODO: axios timeout, 先全部 error 都 retry
    if (isTimoutError) {
      if (retrys >= 0) {
        const result = await getLalamoveQuotation(params, retrys - 1)
        return result
      } else {
        throw new Error('getQuotation Error')
      }
    } else {
      throw new Error('getQuotation Error')
    }
  }
}

export function findDistrict (stops, address) {
  const stop = stops.find(s => s.addresses.zh_HK.displayString === address)
  return stop.district
}



// WEBPACK FOOTER //
// ./src/helpers/lalamovePricing.js